import { render } from "./PostGraduateForm.vue?vue&type=template&id=c4a8c872&ts=true&lang=pug"
import script from "./PostGraduateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostGraduateForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/PostGraduateForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4a8c872"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4a8c872', __exports__)) {
    console.log('reload')
    api.reload('c4a8c872', __exports__)
  }
  
  module.hot.accept("./PostGraduateForm.vue?vue&type=template&id=c4a8c872&ts=true&lang=pug", () => {
    console.log('re-render')
    api.rerender('c4a8c872', render)
  })

}


export default __exports__